import { render, staticRenderFns } from "./Threats.vue?vue&type=template&id=78726ff7&"
import script from "./Threats.vue?vue&type=script&lang=js&"
export * from "./Threats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports